import React, { useContext, useState, useEffect } from 'react';
import { AccountListContext } from '../../../context/AccountListContext';
import { COMPANY_LOGO_BASE_URL } from '../../../config/apiConfig';
import { formatValueInBillions, numberWithCommas, smartRevenueDisplay, truncateDescription, getUserStatsObject, recordActivity } from '../../../services/commonService';
import PlainModal from '../../HtmlElements/PlainModal';
import SlicedCircle from '../../HtmlElements/SlicedCircle';
import * as FeatherIcon from 'react-feather';
import { Link, useParams, useLocation } from 'react-router-dom';
import { useUser } from '../../../context/UserContext';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import RelevanceScore from '../../HtmlElements/RelevanceScore';
import ScreenLoader from '../../HtmlElements/ScreenLoader';

export default function AllAccountsTileView({searchTerm = "", handleAccountPlanDownload}) {
    const { user, my_favourites } = useUser();
    const { accountId, clientName } = useParams(); 
    const { allAccounts, favouriteAccounts, toggleFavourite, loading } = useContext(AccountListContext);

    const [currentRecords, setCurrentRecords] = useState([]); // State for current page records
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage] = useState(9);
    const [sortField, setSortField] = useState('CAGR');
    const [sortOrder, setSortOrder] = useState('desc');
    const [totalPages, setTotalPages] = useState(0);

    const [showMoreModalData, setShowMoreModalData] = useState([]);    // const [nthKc, setNthKc] = useState(0);
    // const nonTruncatedKc = [];
    // const tempKcTitles = [];

    const [all_accounts, setAllAccountsData] = useState(allAccounts || []);
    var currentUrl = useLocation().pathname;
    useEffect(()=> {
        let my_favourites_acc = my_favourites?.account || [];
        const favouriteAccountList = favouriteAccounts || [];
        const favouriteNamesSet_1 = favouriteAccountList.map(fav => fav.name);
        const favouriteNamesSet_2 = my_favourites_acc.map(fav => fav.account_name);
        const favouriteNamesSetArr = [...favouriteNamesSet_1, ...favouriteNamesSet_2];
        const favouriteNamesSet = new Set(favouriteNamesSetArr)

        // Mark accounts as favourite
        const accountsWithFavourites = allAccounts?.map((account) => {
            const updatedAccount = { ...account };  // Create a copy to avoid direct mutation
            updatedAccount.isFavourite = favouriteNamesSet.has(account.name) ? 1 : 0;
            return updatedAccount;
        });

        // Sort accounts by isFavourite
        const sortedAccounts = accountsWithFavourites.sort((a, b) => b.isFavourite - a.isFavourite);
        setAllAccountsData(sortedAccounts);

    }, [my_favourites, allAccounts, loading, favouriteAccounts]);

    useEffect(() => {
        const filteredRecords = all_accounts.filter(record =>
            record.name.toLowerCase().includes(searchTerm.toLowerCase())
        );

        const indexOfLastRecord = currentPage * perPage;
        const indexOfFirstRecord = indexOfLastRecord - perPage;
        // const current_records = all_accounts.slice(indexOfFirstRecord, indexOfLastRecord);
        const current_records = filteredRecords.slice(indexOfFirstRecord, indexOfLastRecord);
        setCurrentRecords(filteredRecords); // Set current page records
        setTotalPages(Math.ceil(all_accounts.length / perPage));
    }, [currentPage, all_accounts, sortField, sortOrder, loading, searchTerm]);

    const handleFirstPage = () => {
        const userStat = getUserStatsObject("All Companies", "pagination", "Data: 1, Page Source: Companies", currentUrl);
        recordActivity(userStat);
        setCurrentPage(1);
    };

    const handleLastPage = () => {
        const userStat = getUserStatsObject("All Companies", "pagination", "Data: "+totalPages+", Page Source: Companies", currentUrl);
        recordActivity(userStat);
        setCurrentPage(totalPages);
    };

    const handlePrevPage = () => {
        if (currentPage > 1){
            const userStat = getUserStatsObject("All Companies", "pagination", "Data: "+(currentPage - 1)+", Page Source: Companies", currentUrl);
            recordActivity(userStat);
            setCurrentPage(currentPage - 1);
        };
    };

    const handleNextPage = () => {
        if (currentPage < totalPages){
            const userStat = getUserStatsObject("All Companies", "pagination", "Data: "+(currentPage + 1)+", Page Source: Companies", currentUrl);
            recordActivity(userStat);
            setCurrentPage(currentPage + 1);
        };
    };

    const handlePageChange = (pageNumber) => {
        const userStat = getUserStatsObject("All Companies", "pagination", "Data: "+pageNumber+", Page Source: Companies", currentUrl);
        recordActivity(userStat);
        setCurrentPage(pageNumber);
    };
    
    const getPageNumbers = () => {
        const pageNumbers = [];
        const startPage = Math.max(1, currentPage - 2);
        const endPage = Math.min(totalPages, currentPage + 2);
        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }
        return pageNumbers;
    };    

    const handleMore = (account) => {
        setShowMoreModalData(account || []);
    };

    const handleClose = () => {
        setShowMoreModalData([]);
    };

    return (
        <div className="row">
            {currentRecords.map((account, index) => {
                let truncated_industryInfo = truncateDescription(account?.company_details?.[0]?.trbc_industry_name, 15);
                let truncated_industry = truncated_industryInfo?.isTruncated ? truncated_industryInfo.truncated_info + "..." : truncated_industryInfo.truncated_info;
                let accountStatus = account?.status;
                let account_description = account?.company_details?.[0]?.business_description ? account.company_details[0].business_description : account?.overview[0]?.text

                let account_displayname = account?.company_details?.[0]?.display_name ? account?.company_details?.[0]?.display_name : account.name
                account.relevance_score = account?.relevance_score ? account.relevance_score : (Math.floor(Math.random() * (90 - 61) + 61)) 

                return (
                    <div className="col-md-4" key={index}>
                        {accountStatus ? (
                            <div className="all_account_tile">
                                <div className={`all_account_icon_block ${index % 2 === 1 ? 'red_back_tiles': '' }`}>
                                    {/* <button
                                        className='mt-2 mr-2'
                                        style={{
                                            width: "161px",
                                            height: "25px",
                                            top: "12px",
                                            left: "235px",
                                            padding: "5px 6px 5px 6px",
                                            backgroundColor: "#FAFAFB",
                                            border: "1px solid #DFDEE8",
                                            borderRadius: "6px",
                                            color: "#363B4B",
                                            fontSize: "11.5px",
                                            fontWeight: "500",
                                            lineHeight: "14.38px"
                                        }}
                                        onClick={() => handleAccountPlanDownload(account?.company_code, account?.client_code)}
                                    >
                                        <img src="/img/icons/download_arrow.png" style={{width: "14px", height: "14px"}} class="download_arrow"></img>
                                        <span
                                            style={{paddingLeft: "2px", width: "131px", height: "15px"}}
                                        >
                                            Download Account Plan
                                        </span>
                                    </button> */}
                                    {/* <i onClick={() => toggleFavourite(account._id)} className={`fa ${account.isFavourite ? 'fa-bookmark' : 'fa-bookmark-o'}`} aria-hidden="true"> </i> */}
                                </div>
                                <div className="clearfix"></div>
                                <div className="all_account_block">
                                    <div className="all_account_subblock">
                                        <Link to={`/account_details/${account._id}/${account.name}/${account?.client}`}>
                                            <img src={`${COMPANY_LOGO_BASE_URL}${encodeURIComponent(account?.name)}`} alt="image" className="all_account_icon_img" />
                                        </Link>
                                    </div>

                                    <h5 className="all_account_head">
                                        <Link className="account_title_link" to={`/account_details/${account._id}/${account.name}/${account?.client}`}>
                                            {account_displayname}   
                                        </Link>
                                    </h5>

                                    <p className="all_account_info_para">
                                        {account_description}
                                    </p>
                                    
                                    {account_description && (
                                    <p className='show_more' onClick={() => handleMore(account)}>
                                        <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
                                    </p>
                                    )}

                                    <div className="d-flex pie_info">
                                        {account.relevance_score && (
                                            <>
                                                <a href="#" className="pie_number">
                                                    <span>{<RelevanceScore relevanceScore={account.relevance_score} />}%</span>
                                                </a>
                                                {/* <a href="#" className="account_slice">
                                                    <SlicedCircle percentage={account.relevance_score} />
                                                </a> */}
                                            </>
                                        )}

                                        {truncated_industry && (
                                            <a href="#">
                                                <span key={index}>
                                                    <OverlayTrigger
                                                        placement='top'
                                                        overlay={<Tooltip className="custom-tooltip">{account?.company_details?.[0]?.trbc_industry_name}</Tooltip>}
                                                        key={index}
                                                    >
                                                        <button className="pie_trend">
                                                            <i className="fa fa-building" aria-hidden="true"></i> {truncated_industry}
                                                        </button>
                                                    </OverlayTrigger>
                                                </span>
                                            </a>
                                        )}

                                        {account?.financials?.[0]?.financials?.[0]?.value && (
                                            <a href="#" className="pie_number">
                                                <span>
                                                    {/* <img src="/img/icons/pie_icon.png" alt="image" className="pie_icon" /> */}
                                                    $ {formatValueInBillions(account?.financials?.[0]?.financials?.[0]?.value)} Bn
                                                </span>
                                            </a>
                                        )}

                                        {account?.opportunity_count && (
                                            <span className="pie_number">
                                                <FeatherIcon.Zap style={{color: "#E67B1E", width: "12px", height: "12px"}} className='icons_table ' />{" "}
                                                {account?.opportunity_count ? account?.opportunity_count : 100}{" "}
                                            </span>
                                        )}

                                        {account?.contact_count && (
                                        <span className="pie_number">
                                            <FeatherIcon.User style={{color: "#1E74E6", width: "12px",  height: "12px"}} className='icons_table ' />{" "}
                                            {account?.contact_count || 75}{" "}
                                        </span>
                                        )}

                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className='almost_block'>
                                <div className='circle_ready'>
                                    <div id="outer-circle">
                                        <div id="inner-circle"></div>
                                    </div>
                                    <p className='getting_ready'>Getting ready</p>
                                    {/* <div className="all_account_icon_block cursorP" onClick={() => toggleFavourite(account._id)}>
                                        <i className={`fa ${account.isFavourite ? 'fa-bookmark' : 'fa-bookmark-o'}`} aria-hidden="true"></i>
                                    </div> */}
                                </div>
                                <div className='almost_there_block'>
                                    <img src={`${COMPANY_LOGO_BASE_URL}${encodeURIComponent(account?.name)}`} alt="image" className="company_logo" />
                                    <h6 className="almost_head">Almost There!</h6>
                                    <p className='almost_para'>Your <span className='strong_span'>{account.name}</span> Account setup is in progress.</p>
                                </div>
                            </div>
                        )}
                    </div>
                );
            })}
        <div>
            <nav className="table_pagination_custom">
                
                {(all_accounts.length > perPage) && <ul className="showing-per-page-info">
                    <li className='page-item'>
                        <span className='showing'>Showing </span> {all_accounts.length > 0 ? ((currentPage - 1) * perPage) + 1 : 0}-
                        {Math.min(currentPage * perPage, all_accounts.length)} of {numberWithCommas(all_accounts.length)}
                    </li>
                </ul>}

                {(all_accounts.length > perPage) && <ul className="pagination">
                    <li
                    className={`page-item ${
                        currentPage === 1 ? "disabled" : ""
                    }`}
                    >
                    <button onClick={handleFirstPage} className="page-link">
                        First
                    </button>
                    </li>
                    <li
                    className={`page-item ${
                        currentPage === 1 ? "disabled" : ""
                    }`}
                    >
                    <button onClick={handlePrevPage} className="page-link">
                    <i className="fa fa-angle-left" aria-hidden="true"></i>
                    </button>
                    </li>
                    {getPageNumbers().map((pageNumber) => (
                    <li
                        key={pageNumber}
                        className={`page-item ${
                        pageNumber === currentPage ? "active" : ""
                        }`}
                    >
                        <button
                        onClick={() => handlePageChange(pageNumber)}
                        className="page-link"
                        >
                        {pageNumber}
                        </button>
                    </li>
                    ))}
                    <li
                    className={`page-item ${
                        currentPage === totalPages ? "disabled" : ""
                    }`}
                    >
                    <button onClick={handleNextPage} className="page-link">
                    <i className="fa fa-angle-right" aria-hidden="true"></i>
                    </button>
                    </li>
                    <li
                    className={`page-item ${
                        currentPage === totalPages ? "disabled" : ""
                    }`}
                    >
                    <button onClick={handleLastPage} className="page-link">
                        Last
                    </button>
                    </li>
                </ul>}
            </nav>
        </div>
            
            {Object.keys(showMoreModalData)?.length > 0 
                && <PlainModal 
                        title={showMoreModalData?.name} 
                        text={showMoreModalData?.company_details?.[0]?.business_description ? showMoreModalData.company_details[0].business_description : showMoreModalData?.overview?.[0]?.text} 
                        handleClose={handleClose} 
                />
            }
        </div>
    );
}

